var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"itemsVisible":_vm.itemsVisible,"itemsInModal":_vm.itemsInModal,"hasModal":_vm.hasModal})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }